import { render, staticRenderFns } from "./my-collect-topic.vue?vue&type=template&id=09154b0b&scoped=true&"
import script from "./my-collect-topic.vue?vue&type=script&lang=js&"
export * from "./my-collect-topic.vue?vue&type=script&lang=js&"
import style0 from "./my-collect-topic.vue?vue&type=style&index=0&id=09154b0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09154b0b",
  null
  
)

export default component.exports